import type { ParsedUrlQuery } from 'querystring';

import { EN_DASH } from 'Utilities/consts';

import type { PaginationDirections, PaginationMeta } from './Pagination.types';

export const getPaginationRange = ({ page, recordsPerPage, totalRecords }: PaginationMeta): string => {
	const lowerBound = (page - 1) * recordsPerPage + 1;
	const upperBound = Math.min(page * recordsPerPage, totalRecords);

	return `${lowerBound} ${EN_DASH} ${upperBound} `;
};

export const getButtonState = (direction: PaginationDirections, paginationMeta: PaginationMeta): boolean => {
	const { page, recordsPerPage, totalRecords } = paginationMeta;

	if (direction === 'back') {
		return page === 1;
	}

	if (direction === 'forward') {
		return page * recordsPerPage >= totalRecords;
	}

	return false;
};

export const getPaginationState = (isDisabled: boolean, totalRecords: number): boolean =>
	isDisabled || totalRecords === 0;

export const resolveQueryParamsWithPage = (pageNumber: number, otherQueryParams?: ParsedUrlQuery): ParsedUrlQuery => ({
	...otherQueryParams,
	page: `${pageNumber}`,
});
